import { Component, OnInit, Input } from '@angular/core';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { VEFunction } from 'app/private/sxfdesigner/types/view-engine.interface';

@Component({
  selector: 'functions-view-engine-tab',
  templateUrl: './functions-view-engine.component.html',
})
export class FunctionsViewEngineComponent implements OnInit {
  constructor(private ngxSmartModalService: NgxSmartModalService) {}
  @Input() attributes: any;

  functions: string[] = [];
  objectKeys = Object.keys;
  activeTab = '';
  newFunction = '';

  ngOnInit(): void {
    const configuration = this.attributes.find((func) => func.name === 'configuration');
    if(configuration.value.functions != null ) {
      this.objectHablding(configuration.value.functions);
    } else configuration.value.functions = {};
      
    this.functions = configuration.value.functions;
  }

  objectHablding(functions): void {
    for (let func in functions) {
      if (functions[func] == null) {
        functions[func] = <VEFunction>{
          type: 'customJS',
          name: func,
          trigger: '',
          code: '',
        };
      }
    }
  }

  addDynFunction(): void {
    if (this.newFunction !== '') {
      this.functions[this.newFunction] = <VEFunction>{
        type: 'dynamic',
        name: this.newFunction,
        trigger: 'onAttributeChange',
        code: '',
      };
      this.newFunction = '';
    }
  }

  deleteFunc(key): void {
    delete this.functions[key];
  }

  changingTab(event: NgbTabChangeEvent): void {
    this.activeTab = event.nextId;
  }

  openCodeModal(name): void {
    this.ngxSmartModalService.setModalData({}, name);
    this.ngxSmartModalService.getModal(name).open();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/modals/view-engine/tabs/functions/functions-view-engine.component.ts